/**
 *
 * Usage:
 *
 *   data-sw-prevent-empty
 *   pattern="<REGEX_PATTERN_TO_MATCH>" last value applied on RegEx fail 
 *
 *
 */

var $ = require('./../sw-jquery');

var attrSelector = '[data-sw-prevent-empty]';
var lastValueDataAttr = 'swPreventEmptyLastValue';

function isEmpty(val) {
  return val === '';
}

$(function() {
  var $body = $('body');

  $body.on('focus', attrSelector, function() {
    var $el = $(this);
    $el.data(lastValueDataAttr, $el.val());
  });

  $body.on('blur', attrSelector, function() {
    var $el = $(this);
    var lastVal;
    if(isEmpty($el.val())) {
      lastVal = $el.data(lastValueDataAttr);
      $el.val(lastVal);
    }
  });
}); 